var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationSparklinkgBigIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 124,
    fill: "none",
    viewBox: "0 0 168 124",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F3FF",
    stroke: "#9DD3FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M83.9064 68.6408 64.1455 84.1201l-22.1457 4.3923 36.3437 21.7806 22.1395-4.851 15.664-16.5314 14.609-.5672 14.752-17.2977-36.547-21.5933-14.9303 17.2674z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9DD3FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m64.311 84.1499 36.076 21.2861M84.0698 69.1316l32.2362 19.7722M94.1545 66.635l36.5705 21.6477"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE8FF",
    d: "M46.848 11.2792c-1.4379 0-2.6078-1.1821-2.6078-2.635s1.1699-2.635 2.6078-2.635 2.6078 1.1822 2.6078 2.635c0 1.4529-1.1699 2.635-2.6078 2.635m0-4.2284c-.8709 0-1.577.7134-1.577 1.5934 0 .8801.7061 1.5935 1.577 1.5935s1.5771-.7134 1.5771-1.5935-.7061-1.5934-1.5771-1.5934"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M131.112 122.115c-1.438 0-2.608-1.182-2.608-2.635s1.17-2.635 2.608-2.635 2.608 1.182 2.608 2.635-1.17 2.635-2.608 2.635m0-4.228c-.871 0-1.577.713-1.577 1.593s.706 1.593 1.577 1.593 1.577-.713 1.577-1.593-.711-1.593-1.577-1.593"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE8FF",
    d: "M135.75 12.8158c-1.438 0-2.607-1.1821-2.607-2.635s1.169-2.635 2.607-2.635 2.608 1.1821 2.608 2.635-1.17 2.635-2.608 2.635m0-4.2232c-.871 0-1.577.7134-1.577 1.5934 0 .8801.706 1.5935 1.577 1.5935s1.577-.7134 1.577-1.5935-.711-1.5935-1.577-1.5935M165.392 109.154c-1.438 0-2.608-1.183-2.608-2.635 0-1.453 1.17-2.635 2.608-2.635s2.608 1.182 2.608 2.635c0 1.452-1.17 2.635-2.608 2.635m0-4.224c-.871 0-1.577.714-1.577 1.594s.706 1.593 1.577 1.593 1.577-.713 1.577-1.593-.711-1.594-1.577-1.594"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#80C6FF",
    d: "M2.6078 63.0936C1.17 63.0936 0 61.9115 0 60.4586s1.17-2.635 2.6078-2.635c1.438 0 2.6078 1.1821 2.6078 2.635s-1.1699 2.635-2.6078 2.635m0-4.2285c-.871 0-1.577.7135-1.577 1.5935 0 .8801.706 1.5935 1.577 1.5935s1.577-.7134 1.577-1.5935-.706-1.5935-1.577-1.5935M86.8511 1.8851h-1.0926V.7811c0-.4322-.3453-.7811-.7731-.7811s-.7731.3489-.7731.7811v1.104h-1.0926c-.4277 0-.773.3489-.773.7811s.3453.7811.773.7811h1.0926v1.104c0 .4322.3453.7811.7731.7811s.7731-.3489.7731-.781v-1.104h1.0926c.4277 0 .773-.349.773-.7812s-.3453-.7811-.773-.7811M6.4526 97.119H5.36v-1.104c0-.4322-.3453-.7811-.773-.7811s-.773.3489-.773.7811v1.104H2.7212c-.4278 0-.773.3489-.773.7811s.3452.7811.773.7811H3.814v1.104c0 .4318.3453.7808.773.7808s.7731-.349.7731-.7808v-1.104h1.0926c.4278 0 .7731-.3489.7731-.7811s-.3453-.7811-.773-.7811"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.2212 120.553h-1.0926v-1.104c0-.433-.3453-.781-.7731-.781s-.773.348-.773.781v1.104h-1.0926c-.4278 0-.7731.349-.7731.781s.3453.781.7731.781h1.0926v1.104c0 .432.3453.781.773.781s.7731-.349.7731-.781v-1.104h1.0926c.4277 0 .7731-.349.7731-.781s-.3454-.781-.7731-.781"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE8FF",
    d: "M167 69.2593h-1.092v-1.104c0-.4322-.345-.7811-.773-.7811s-.773.3489-.773.7811v1.104h-1.093c-.428 0-.773.3489-.773.7811s.345.7811.773.7811h1.093v1.104c0 .4322.345.7811.773.7811s.773-.3489.773-.7811v-1.104H167c.428 0 .774-.3489.774-.7811s-.346-.7811-.774-.7811"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EAEED",
    stroke: "#5EAEED",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.3793,
    d: "M92.2897 33.9524c-.921-.7381-2.4154-1.6499-3.5194-2.1844a15.01 15.01 0 0 0-6.1726-1.5034h-.0459c-1.1961-.0292-2.3921.1754-3.5004.6306-3.0402 1.2528-5.7877 3.2072-7.9581 5.6753-2.1956 2.4972-3.7931 5.5123-4.6169 8.7196a12.25 12.25 0 0 0-.3764 3.1194c.0125 2.8731.4809 5.7337 1.4637 8.4314 2.413 6.6274 6.4067 12.6576 10.756 18.3287 1.0454 1.3655 1.6928 2.4346 3.2694 3.1195l2.7796 1.2407"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE8FF",
    stroke: "#B3DDFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5862,
    d: "M84.5527 79.7143c2.7559-5.55 6.3271-11.1765 9.083-16.7223 2.9651-5.9717 6.0095-12.3235 5.4742-18.9718-.2551-3.1904-1.4428-6.4352-3.8683-8.5274-1.5724-1.3572-3.5797-2.1548-5.6331-2.4472-5.0601-.7266-10.3085 1.6329-13.5955 5.5416-3.287 3.9089-4.7172 9.1748-4.4872 14.2737s2.0241 10.0392 4.5584 14.47c2.5383 4.4308 4.9849 8.4788 8.4685 12.3834"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EAEED",
    d: "M91.6577 53.9417c2.1879-4.3868 1.26-9.2867-2.0725-10.9441-3.3326-1.6575-7.8078.5552-9.9958 4.9421s-1.2601 9.2868 2.0725 10.9442 7.8078-.5553 9.9958-4.9422"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#B3DDFF",
    strokeMiterlimit: 10,
    strokeWidth: 2.3793,
    d: "M91.6577 53.9416c2.1879-4.3868 1.26-9.2867-2.0725-10.9441-3.3326-1.6575-7.8078.5552-9.9958 4.9421s-1.2601 9.2868 2.0725 10.9443c3.3325 1.6573 7.8078-.5554 9.9958-4.9423Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3DDFF",
    strokeMiterlimit: 10,
    strokeWidth: 2.3793,
    d: "M86.2414 42.4543c1.2631 2.2844 1.2505 5.5918-.2717 8.6529-1.5599 3.1236-4.274 5.1448-6.917 5.4497"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationSparklinkgBigIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-sparklinkg-big-icon.84d80ee54d37cb6a1526ec674fa586b4.svg";